export enum AttachmentTabs {
    TaskDescription = 'task-description',
    Solution = 'task-solution',
}
